var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 6c.483 0 .875.392.875.875v4.25a.876.876 0 01-.875.875h-3.25A.876.876 0 017 11.125v-4.25C7 6.392 7.393 6 7.875 6zM8.75 0c.483 0 .875.392.874.875v.953c0 .371-.153.732-.42.99L6.192 5.725a.628.628 0 00-.191.45v1.99c0 .402-.175.783-.48 1.044l-1.401 1.2a.373.373 0 01-.4.056.374.374 0 01-.219-.34v-3.96a.63.63 0 00-.183-.442L.403 2.81A1.365 1.365 0 010 1.838V.875C0 .392.392 0 .875 0zm1.375 9.5h-1.25a.375.375 0 000 .75h1.25a.375.375 0 000-.75zm0-1.5h-1.25a.375.375 0 000 .75h1.25a.375.375 0 000-.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default ForwardRef;